import styled, { css } from "styled-components/macro";
import { Box, Grid, Typography } from "@material-ui/core";

export const ListContainer = styled(Box)`
    padding: 12px;
    max-height: 200px;
    min-height: 100px;
    overflow: auto;
    padding-top: 9px;
    padding-left: 0;
`;

export const SequenceList = styled(Box)`
    height: 32px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 5px;
`;

export const SequenceNumber = styled(Box)`
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    color: #545454;
    ${props => (props.ml ? css`margin-left: ${props.ml};` : "" )}
    min-width: 33px;
`;

export const NextSequenceList = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 90%;
    > div {
        margin-left: 3px;
    }
`;

export const SequenceText = styled(Typography)`
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
    color: #393939;
    font-size: 0.97rem !important;
    padding-left: 5px;
`;

export const InfoText = styled(Grid)`
    margin-top: 7px !important;
    margin-bottom: 5px !important;
    padding-top: 10px !important;
    padding-left: 20px !important;
    > p {
        font-size: 12.5px !important;
    }
`;

export const TypeContainer = styled(Grid)`
    margin-top: 10px !important;
    margin-left: 20px !important;
    > div {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 5px;
        label {
            color: #333;
            font-weight: 600;
            margin-bottom: 0;
            font-size: 12px;
        }
        p {
            margin-left: 5px;
            color: #333;
            font-size: 12px !important;
        }
    }
`;

export const OrderContainer = styled(Grid)`
    margin-top: 10px;
    margin-left: 20px;
    margin-top: 10px;
    > div > h5 {
        margin-bottom: 0;
        color: #333;
        font-size: 1.2rem !important;
    }
`;

export const SubTitle = styled(Typography)`
   margin-bottom: 10px !important;
   color: #333;
   font-weight: 500 !important;
`;

export const ChillerRotateButton = styled.div`
    color: #fff;
    background-color: #333333;
    height: 34px;
    width: 155px;
    font-weight: 600;
    font-family: Verdana;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: normal;
    word-wrap: break-word;
    cursor: pointer;
    &:hover {
        background-color: #000;
    }
`;

export const FormContainer = styled(Box)`
    padding-left: 30px;
    margin-bottom: 10px;
     > div > p {
        margin-bottom: 3px;
     }
     > div > div {
        width: 100%;
        > div {
            width: 100%;
        }
     }
    > div > div > div {
        height: 50px;
        input {
            width: 93%;
            height: 32px !important;
        }
        > div {
            margin-top: 1px;
        }
    }
`;

export const ErrorMessageContainer = styled(Box)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-height: 26px;
    padding-left: 30px;
    svg {
        color: #C31200;
        font-size: 16px;
        cursor: normal;
        margin-right: 5px;
    }
    p {
        color: #C31200;
        font-size: 12px !important;
    }
`;

export const SequenceItem = styled(Box)`
    margin-bottom: 5px;
    padding-left: 8px;
    border: 1px solid rgb(204, 204, 204);
    border-radius: 6px;
    box-shadow: 0px 0px 1px 0px lightgray;
    width: 220px;
    height: inherit;
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #393939;
    font-size: 0.97rem !important;
    padding-top: 9px;
`;

export const LoginError = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 5px;
    svg {
        width: 30px;
    }
`;